import { adminHttpClient } from '../../../commons/adminHttpClient'

const getEligibleEmployeeRenewalTemplate = (): Promise<any> => {
  return adminHttpClient.get('/AdminDashboard/Renewal/NotifyEmployees/EligibleEmployeeEmailTemplate')
}

export default getEligibleEmployeeRenewalTemplate
